import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const tryAIFilters = style({
  display: 'flex',
  flexDirection: 'row',
  padding: space.s12,
  gap: space.s8,
  borderRadius: borderRadius.r8,
  border: `1px solid ${themeVars.container.border.default}`,
  backgroundColor: themeVars.container.primary.background.idle,
});

export const tryAIFiltersContent = style({
  display: 'flex',
  gap: space.s4,
  flexDirection: 'column',
});

export const tryAIFiltersHeader = style([
  typography.titleMd,
  {
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: space.s4,
    color: themeVars.link.idle,
  },
]);

export const tryAIFiltersDescription = style([
  typography.bodyMd,
  {
    marginTop: space.s8,
    marginBottom: space.s16,
    color: themeVars.container.foreground.secondary,
  },
]);

export const goToSettingsButton = style({
  width: 'fit-content',
});

export const aiFiltersContainer = style([
  tryAIFilters,
  {
    flexDirection: 'column',
    gap: space.s12,
  },
]);

export const aiFiltersHeader = style({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: space.s16,
  flexWrap: 'wrap',
});

export const aiFiltersHeaderAside = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: space.s8,
});

export const aiFiltersHeaderTitle = style([
  typography.titleMd,
  {
    color: themeVars.link.idle,
  },
]);

export const aiFiltersFooter = style({
  display: 'flex',
  flexDirection: 'row',
  gap: space.s16,
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const aiFiltersHeaderPlan = style([
  typography.bodySm,
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const aiFilterSelectItem = style({
  display: 'flex',
  gap: space.s12,
});

export const aiFilterSelectTrigger = style({
  width: '100%',
});

export const backButton = style({
  marginRight: space.s16,
});

export const createFilterButton = style({
  marginTop: space.s16,
  width: 'fit-content',
  alignSelf: 'center',
});

export const filterSelectContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: space.s2,
});

export const filterSelectName = style([
  typography.titleSm,
  {
    wordBreak: 'break-word',
  },
]);

export const filterSelectPrompt = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
]);

export const aiFiltersLoading = style({
  height: '38px',
  display: 'flex',
  alignItems: 'center',
});
